<template lang='pug'>
  v-app#app
    bionic-metrics-loading-bar
    bionic-metrics-header
    v-content
      router-view
    bionic-metrics-footer
    bionic-metrics-alert
</template>
<script>
import BionicMetricsHeader from './components/Header';
import BionicMetricsFooter from './components/Footer';
import BionicMetricsLoadingBar from './components/LoadingBar';
import BionicMetricsAlert from './components/Alert';

export default {
  beforeCreate() {},
  components: {
    BionicMetricsAlert,
    BionicMetricsLoadingBar,
    BionicMetricsHeader,
    BionicMetricsFooter
  },
  name: 'app'
};
</script>

<style lang="scss">
  html, body {
    overflow-x: hidden;
  }

  .spaced-divider {
    margin-bottom: 30px;
  }

  .full-height {
    height: 100%;
  }

  .flush-right {
    margin-right: 0;
  }

  #app {
    position: relative;
  }

  .outline {
    outline: 2px dashed blue;
  }
</style>
